import { getFunctions, httpsCallable } from 'firebase/functions';

/**
 * Single chunk kick (server processes one file then returns).
 * Prefer runSchemaV2EvidenceWorkersUntilDone for Analyse / Resume.
 */
export function kickSchemaV2EvidenceWorkers(schoolId, options = {}) {
  const force = options.force === true;
  const retryFailed = options.retryFailed === true;
  const fn = httpsCallable(getFunctions(), 'processSchemaV2EvidenceJob', {
    timeout: 540000,
  });
  return fn({ schoolId, force, retryFailed });
}

/**
 * Chain one-file server chunks until the vault is finished (or busy/error).
 * Keeps running after the progress modal is hidden, as long as this promise is alive
 * (e.g. started from SchoolRow Analyse / Resume).
 */
export async function runSchemaV2EvidenceWorkersUntilDone(schoolId, options = {}) {
  let force = options.force === true;
  let retryFailed = options.retryFailed === true;
  let first = true;
  let guard = 0;
  let last = null;

  while (guard < 250) {
    guard += 1;
    const result = await kickSchemaV2EvidenceWorkers(schoolId, {
      force: force || !first,
      retryFailed: first && retryFailed,
    });
    first = false;
    retryFailed = false;
    last = result?.data || result;

    if (!last || last.ok === false) {
      if (last?.reason === 'busy') {
        await new Promise((r) => setTimeout(r, 4000));
        force = true;
        continue;
      }
      break;
    }

    if (last.paused || Number(last.queued || 0) > 0) {
      force = true;
      continue;
    }
    break;
  }

  return last;
}
